import { computed, defineComponent, ref } from 'vue';
import IconMap from './../../assets/icon';
import TLoading from './../t-loading/index';
import TIcon from './../t-icon/index';
export default defineComponent({
    name: 'TButton',
    components: { TLoading, TIcon },
    props: {
        text: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        isAutoHeight: {
            type: Boolean,
            default: false,
        },
        /** 组件内部元素的排版对齐方向 */
        direction: {
            type: String,
            default: 'row',
            validator: (value) => ['row', 'column'].includes(value),
        },
        orientation: {
            type: String,
            default: 'center',
            validator: (value) => ['left', 'right', 'center'].includes(value),
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge'].includes(value),
        },
        theme: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'primary', 'link', 'text', 'dark', 'disabled'].includes(value),
        },
        iconName: {
            type: String,
            default: '',
        },
    },
    emits: ['click'],
    setup(props, context) {
        const prefixCls = ref('t-button');
        // 按钮的外观颜色
        const getTheme = computed(() => (props.selected ? 'selected' : props.theme));
        // 是否需要loading效果
        const getIsLoading = computed(() => props.loading);
        // 图标名称
        const getIconName = computed(() => IconMap[props.iconName]) ? props.iconName : '';
        // 图标的外观颜色
        const getIconTheme = computed(() => {
            let output = props.theme;
            if (['primary', 'text'].includes(props.theme)) {
                output = 'default';
            }
            if (props.theme === 'dark') {
                output = 'highlight';
            }
            if (props.theme === 'disabled' || props.disabled) {
                output = 'disabled';
            }
            return output;
        });
        const getClasses = computed(() => {
            return {
                wrap: [
                    `${prefixCls.value}`,
                    `${prefixCls.value}-${props.direction}`,
                    `${prefixCls.value}-${props.orientation}`,
                    !props.disabled && `${prefixCls.value}-${getTheme.value}`,
                    !props.isAutoHeight && `${prefixCls.value}-${props.size}`,
                    getIsLoading.value && `${prefixCls.value}-loading`,
                    props.isAutoHeight && `${prefixCls.value}-auto__${props.size}`,
                    props.disabled && getTheme.value !== 'dark' && `${prefixCls.value}-disabled`,
                    props.disabled && getTheme.value === 'dark' && `${prefixCls.value}-disabled__dark`,
                ],
                title: [
                    `${prefixCls.value}-txt`,
                    `${prefixCls.value}-txt__${props.size}`,
                    !props.disabled && `${prefixCls.value}-txt__${getTheme.value}`,
                    props.disabled && getTheme.value !== 'dark' && `${prefixCls.value}-disabled-txt`,
                    props.disabled && getTheme.value === 'dark' && `${prefixCls.value}-disabled-txt__dark`,
                ],
                description: [`${prefixCls.value}-desc`],
            };
        });
        /** 对外响应的事件 */
        const listener = (event) => {
            if (!(props.disabled || getIsLoading.value)) {
                context.emit('click', event);
            }
            return null;
        };
        return { getIsLoading, prefixCls, getClasses, getIconName, getIconTheme, listener };
    },
});
